module.exports = __webpack_public_path__ + "media/images/icons/icon-gradient-star-86f5a6f90be45f60428ef7df9854a250.svg";